// extracted by mini-css-extract-plugin
export default {"itemsContainer":"SelectorZonesBed_itemsContainer__YSzi1","activeZoneAdmin":"SelectorZonesBed_activeZoneAdmin__s6eD6","buttonZoneAdmin":"SelectorZonesBed_buttonZoneAdmin__lkH9a"};